import { z } from 'zod';
import { toast } from 'sonner';

export function handleValidationError(error: z.ZodError): void {
  const message = error.errors.map(e => e.message).join(', ');
  console.error('Validation error:', message);
  toast.error(message);
}